/* Version: 3.5.137 */
'use client';
import 'react';
import PropTypes from 'prop-types';
import { KEY } from '../../constants.js';
import i18n from '../../../lang/i18n/index.js';
import Element from '../../../utils/Element.js';
import { SkipLink } from './styledComponents.js';
import { jsx, Fragment } from 'react/jsx-runtime';
import useLang from '../../../hooks/useLang.js';
import useTheme from '../../../hooks/useTheme.js';

var SkipLinks = function SkipLinks(_ref) {
  var mainContentNode = _ref.mainContentNode,
    mainNavNode = _ref.mainNavNode,
    subNavNode = _ref.subNavNode,
    footerNode = _ref.footerNode;
  var lang = useLang();
  var theme = useTheme();
  var skipLinks = [];
  if (mainContentNode) {
    skipLinks.push({
      node: mainContentNode,
      label: 'skipToMainContentLabel',
      id: 'skip-to-content'
    });
  }
  if (mainNavNode) {
    skipLinks.push({
      node: mainNavNode,
      label: 'skipToMainNavLabel',
      id: 'skip-to-main-nav'
    });
  }
  if (subNavNode) {
    skipLinks.push({
      node: subNavNode,
      label: 'skipToSubNavLabel',
      id: 'skip-to-sub-nav'
    });
  }
  if (footerNode) {
    skipLinks.push({
      node: footerNode,
      label: 'skipToFooterLabel',
      id: 'skip-to-footer'
    });
  }
  return /*#__PURE__*/jsx(Fragment, {
    children: skipLinks.map(function (skipTo) {
      function handleSkip() {
        skipTo.node.focus();
      }
      return /*#__PURE__*/jsx(SkipLink, {
        type: "button",
        id: skipTo.id,
        theme: theme,
        onClick: handleSkip,
        onKeyDown: function onKeyDown(event) {
          if (event.key === KEY.ENTER) {
            handleSkip();
            event.preventDefault();
          }
        },
        children: i18n[lang].utilityHeader[skipTo.label]
      }, skipTo.id);
    })
  });
};
process.env.NODE_ENV !== "production" ? SkipLinks.propTypes = {
  /** Node representing the main content area */
  mainContentNode: PropTypes.instanceOf(Element),
  /** Node representing the first main nav item */
  mainNavNode: PropTypes.instanceOf(Element),
  /** Node representing the first sub nav item */
  subNavNode: PropTypes.instanceOf(Element),
  /** Node representing the first footer item */
  footerNode: PropTypes.instanceOf(Element)
} : undefined;

export { SkipLinks as default };
